import ModalCreateEdit from '../../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { ModalComponentProps } from '../../../../../../../baseComponents/ModalsLayouts/types'
import { FormRender } from '../../../../../../../forms/FormRenderer/types'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import { useTypeIdNumber } from '../../../../../../../utils/hooks/useTypeIdNumber'
import { getActiveLangs, getAllClientManagerEmployees, getConfigParam, getDictionaryCountries } from '../../../../../../../utils/reducers/getters'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { addDictionaryExtraLine, dictionaryComplexFromJsonArr, TwinDictionary } from '../../../../../../../utils/globals/dictionary'
import { twinFetchPostJSON } from '../../../../../../../utils/globals/data'
import useCreateCustomerB2BWCAndAddress from '../../../../../../../utils/hooks/customer/useCreateCustomerB2BWCAndAddress'
import { CustomerModelTypeShopAndAddress } from '../../../../../../../specificComponents/Customers/types'
import { CustomerGroupPayload } from '../../../../../../../utils/reducers/customers/customerGroups'
import { connect, ConnectedProps } from 'react-redux'
import { AllReduxPayloads } from '../../../../../../../utils/reducers'
import withLoading from '../../../../../../../utils/hoc/withLoading'
import { EmployeesPayload } from '../../../../../../../utils/reducers/company/employees'
import { returnClassOfSpanTemplate } from '../../../../../../../utils/globals/tailwind'
import { sortCountries } from '../../../../../../../utils/globals/sortCountries'

type ModalCreateContactB2BProps = ModalComponentProps & ReduxModalCreateContactB2B & { }

const ModalCreateContactB2B: React.FC<ModalCreateContactB2BProps> = ({ customerGroups, employees, ...rest }) => {
    const { t } = useTwinTranslation()
    const { typesIdNumber } = useTypeIdNumber()
    const { dictCustomerOrigins, createWorkingCenter, handleShowCreateWorkingCenter, myEmployees } = useModalCreateContactB2BLogic({ employees })
    const { workingCenterFields } = useCreateCustomerB2BWCAndAddress({ createWorkingCenter })
    
    const fields: FormRender<CustomerModelTypeShopAndAddress> = [
        {
            cols: 2,
            elements: [
                {
                    name: 'name',
                    label: t('businessName', 'Nombre comercial'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    required: true
                },
                {
                    name: 'fiscal_name',
                    label: t('fiscalName', 'Nombre fiscal'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
                {
                    name: 'type_id_number',
                    label: t('typeIdNumber', 'Tipo de documento identificación'),
                    component: 'CustomSelect',
                    items: typesIdNumber,
                    value: 0
                },
                {
                    name: 'id_number',
                    label: t('id_number', 'DNI'),
                    component: 'InputWithLabelMargin',
                    type: 'text'
                },
                {
                    name: 'code',
                    label: t('customerCode', 'Código de Cliente'),
                    component: 'InputWithLabelMarginIntegerStateFull',
                },
                {
                    name: 'responsable_name',
                    label: t('responsableName', 'Nombre del responsable'),
                    component: 'InputWithLabelMargin',
                    type: 'text'
                },
                {
                    name: 'ResponsibleEmployeeId',
                    label: t('ourManager', 'Nuestro gestor'),
                    component: 'CustomSelectWithSearchBar',
                    items: myEmployees || {},
                    fieldName: 'fullname_short',
                    sortItems: true
                },
                {
                    name: 'nationality',
                    label: t('nationality', 'Nacionalidad'),
                    component: 'CustomSelectWithSearchBar',
                    items: getDictionaryCountries(),
                    sortFunction: sortCountries,
                },
                {
                    name: 'doVatVerification',
                    component: 'CheckboxMargin',
                    label: t('checkIDNumber', 'Verificar el CIF'),
                    defaultChecked: true
                },
                {
                    name: 'notes',
                    label: t('notes', 'Notas'),
                    component: 'TextArea',
                    parentClassName: returnClassOfSpanTemplate(2)
                },
            ]
        },
        {
            cols: 2,
            title: t('contactInfo', 'Información de contacto'),
            elements: [
                {
                    name: 'customerContactName',
                    label: t('customerContactName', 'Nombre persona de contacto'),
                    component: 'InputWithLabelMargin',
                    type: 'text'
                },
                {
                    name: 'phone',
                    label: t('phone', 'Teléfono'),
                    component: 'InputWithLabelMargin',
                    type: 'text'
                },
                {
                    name: 'mobile',
                    label: t('mobile', 'Móvil'),
                    component: 'InputWithLabelMargin',
                    type: 'text'
                },
                {
                    name: 'email',
                    label: t('email', 'Email'),
                    component: 'InputWithLabelMargin',
                    type: 'email'
                },
                {
                    name: 'web',
                    label: t('web', 'Página web'),
                    component: 'InputWithLabelMargin',
                    type: 'text'
                },
                {
                    name: 'LangId',
                    label: t('language', 'Idioma'),
                    component: 'CustomSelectWithSearchBar',
                    items: getActiveLangs(),
                },
                {
                    name: 'CustomerOriginId',
                    label: t('origin', 'Origen'),
                    component: 'CustomSelectWithSearchBar',
                    items: dictCustomerOrigins || {},
                },
                {
                    name: 'customer_type',
                    component: 'InputHidden',
                    value: 2
                },
                {
                    name: 'createWorkingCenter',
                    component: 'CheckboxMargin',
                    label: t('createWorkingcenter', 'Crear centro de trabajo'),
                    checked: createWorkingCenter,
                    onChange: handleShowCreateWorkingCenter
                }
            ]
        },
        ...workingCenterFields,
        {
            cols: 1,
            title: t('customerType', 'Tipo de cliente'),
            elements: [
                {
                    name: 'customersForParse',
                    component: 'MultipleCheckboxSelector',
                    subtitles: { subtitleOptions: t('notSelected', 'Sin seleccionar'), subtitleSelectedOptions: t('selected', 'Seleccionados') },
                    items: dictionaryComplexFromJsonArr(customerGroups?.B2BContactGroups || []),
                },
            ]
        }
    ]
    return (
        <ModalCreateEdit fields={fields} url={'/api/app/customer/createCustomer'} translations={{
            title: t('createLeadB2B', 'Crear Cliente Potencial B2B'),
            button: t('create', 'Crear')
        }} haveButtonPermissions={true} {...rest} />
    )
}
interface ModalCreateContactB2BLogicProps {
    employees: EmployeesPayload
}
const useModalCreateContactB2BLogic = ({ employees }: ModalCreateContactB2BLogicProps) => {
    const [dictCustomerOrigins, setDictCustomerOrigins] = useState<TwinDictionary | null>(null)
    const [createWorkingCenter, setCreateWorkingCenter] = useState<boolean>(true)

    const myEmployees = useMemo(() => addDictionaryExtraLine(JSON.parse(JSON.stringify(getConfigParam('showOnlyClientManagerEmployees') === 'on' ? getAllClientManagerEmployees() || {} : employees || {}))), [employees])

    const handleShowCreateWorkingCenter = useCallback(() => {
        setCreateWorkingCenter((old) => !old)
    }, [setCreateWorkingCenter])

    const getDictCustomerOrigins = useCallback(async () => {
        const result = await twinFetchPostJSON('/api/app/customer/customerOrigin/getAllCustomerOrigins', {})
        if (result) {
            setDictCustomerOrigins(dictionaryComplexFromJsonArr(result))
        }
    }, [setDictCustomerOrigins])

    useEffect(() => {
        getDictCustomerOrigins()
    }, [getDictCustomerOrigins])

    return { dictCustomerOrigins, createWorkingCenter, handleShowCreateWorkingCenter, myEmployees }
}

const modalCreateContactB2BDispatch = {
    setCustomerGroups: (payload: CustomerGroupPayload) => ({ type: 'CHANGE_CUSTOMER_GROUP', payload }),
    setEmployees: (payload: EmployeesPayload) => ({ type: 'CHANGE_EMPLOYEE', payload }),
}

export type ReduxModalCreateContactB2B = ConnectedProps<typeof ModalCreateContactB2BConnect>
const mapModalCreateContactB2BConnector = (state: AllReduxPayloads) => ({ customerGroups: state.customerGroups, employees: state.employees })
const ModalCreateContactB2BConnect = connect(mapModalCreateContactB2BConnector, modalCreateContactB2BDispatch)

const modalCreateContactB2BConnectLoading = withLoading(ModalCreateContactB2B, [{ fetchUrl: '/api/app/customer/customerGroup/getAllCustomersGroup', propName: 'customerGroups', setFunctionName: 'setCustomerGroups' }, { fetchUrl: '/api/app/employee/getAllEmployees', propName: 'employees', setFunctionName: 'setEmployees' }])

export default ModalCreateContactB2BConnect(modalCreateContactB2BConnectLoading);
